// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"514":"a3a04380","977":"ba026ab0"}[chunkId] + ".chunk.js";
};